{% block topdata_es_suggestion_form %}
    <sw-modal
        :title="formTitle"
        @modal-close="$emit('close')"
        variant="small"
    >
        <sw-text-field
            v-model:value="entity.term"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.term')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.termPlaceholder')"
            required
        />

        <sw-text-field
            v-model:value="entity.title"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.title')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.titlePlaceholder')"
            :help-text="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.titleHelp')"
        />

        <sw-single-select
            v-model:value="entity.languageId"
            :options="languageOptions"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.language')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.languagePlaceholder')"
            :show-clearable="true"
        />

        <sw-select-field
            v-model="entity.targetType"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetType')"
            :options="targetTypeOptions"
            @update:model-value="onTargetTypeChange"
        />

        <sw-entity-single-select
            v-if="entity.targetType === 'category'"
            v-model:value="targetEntityId"
            entity="category"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetCategory')"
            :criteria="categoryCriteria"
            :description-position="'bottom'"
            required
        >
            <template #selection-label-property="{ item }">
                {{ getCategoryBreadcrumb(item) }}
            </template>
            <template #result-label-property="{ item, searchTerm, highlightSearchTerm }">
                <sw-highlight-text
                    v-if="highlightSearchTerm"
                    :text="getCategoryName(item)"
                    :search-term="searchTerm"
                />
                <template v-else>
                    {{ getCategoryName(item) }}
                </template>
            </template>
            <template #result-description-property="{ item }">
                <span v-if="getCategoryShortBreadcrumb(item)" class="tdes-suggestion-form__category-breadcrumb">
                    {{ getCategoryShortBreadcrumb(item) }}
                </span>
            </template>
        </sw-entity-single-select>

        <sw-text-field
            v-if="entity.targetType === 'category'"
            v-model:value="entity.targetQuery"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQuery')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQueryPlaceholder')"
            :help-text="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQueryHelp')"
        />

        <sw-entity-single-select
            v-else-if="entity.targetType === 'product'"
            v-model:value="targetEntityId"
            entity="product"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetProduct')"
            :criteria="productCriteria"
            required
        />

        <sw-text-field
            v-if="entity.targetType === 'search'"
            v-model:value="entity.targetQuery"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQuery')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQueryPlaceholder')"
            :help-text="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetQuerySearchHelp')"
        />

        <sw-text-field
            v-else-if="entity.targetType === 'custom'"
            v-model:value="entity.targetUrl"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetUrl')"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetUrlPlaceholder')"
            :help-text="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetUrlHelp')"
        />

        <div v-if="targetUrlPreview" class="tdes-suggestion-form__preview">
            <sw-label variant="light">
                {{ $tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetUrlPreview') }}:
                <code>{{ targetUrlPreview }}</code>
            </sw-label>
        </div>

        <sw-number-field
            v-model:value="entity.priority"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.priority')"
            :placeholder="0"
        />

        <sw-checkbox-field
            v-model:value="entity.active"
            :label="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.active')"
        />

        <template #modal-footer>
            <sw-button @click="$emit('close')">
                {{ $tc('global.default.cancel') }}
            </sw-button>
            <sw-button variant="primary" @click="onSave" :is-loading="isLoading">
                {{ $tc('global.default.save') }}
            </sw-button>
        </template>
    </sw-modal>
{% endblock %}
